/*========================================================================
 * $Id: main.js 73933 2013-07-23 08:47:30Z michael.biebl $
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

// this plugin has to be special defined in development version to not use
// the path to the source directory

// use "mindbreezeRequire" or "require" (webpack/requireJS )
var useMindbreezeRequire = true;

define([ useMindbreezeRequire ? "mindbreezeRequire" : "require"], function(mindbreezeRequire) {

  return {
    scriptLocation: mindbreezeRequire.toUrl('')
  };
});
